import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

const api = {
  getCouponsDataList: (params) => {
    return sendAxios({
      method: 'get',
      url: '/activity/coupon',
      params,
      baseURL: Domains.lcscActivityUrl,
    });
  },
  buyCouponBagCheck: (params) => {
    return sendAxios({
      method: 'get',
      url: '/async/coupon/bag/check',
      params,
      baseURL: Domains.lcscActivityUrl,
    });
  },
  getCouponById: (uuid) => {
    return sendAxios({
      method: 'get',
      url: '/getCoupon/' + uuid,
      baseURL: Domains.lcscActivityUrl,
    });
  },
};
export default api;
